import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFish = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.585632 7.67279L4.58563 2.67279L8.64624 0.672791V7.67279M0.585632 7.67279L4.58563 12.6728L8.64624 14.6728V7.67279M0.585632 7.67279H14.5856M8.64624 7.67279L14.5856 12.6728V7.67279M8.64624 7.67279L14.5856 2.67279V7.67279",
		stroke: "black",
		strokeWidth: 1.5,
		strokeLinejoin: "bevel"
	})
});
export default SvgFish;
